// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Portado de nuevo_front (consulta-documentos) — modal detalle comprobante */

.invoiceDetailModal_dialogWide__hVPn1 {
  max-width: 1000px;
  width: 100%;
}

.invoiceDetailModal_headerPremium__zLUl\\+ {
  background: #fafafa;
  border-bottom: 1px solid #e5e7eb;
  padding: 1.25rem 1.5rem;
  /* Alineado con el radio del contenedor del modal (esquinas superiores) */
  border-radius: 12px 12px 0 0;
  margin-bottom: 0;
}

.invoiceDetailModal_titlePremium__x-\\+kY {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
  margin: 0;
  flex: 1 1;
  padding-right: 0.5rem;
}

.invoiceDetailModal_closeIcon__CTFl6 {
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
}

.invoiceDetailModal_closeIcon__CTFl6:hover {
  color: #374151;
}

.invoiceDetailModal_bodyWrap__1DwgU {
  background: #fff;
  max-height: min(70vh, 800px);
  overflow-y: auto;
  /* Separación respecto al header premium */
  padding: 1.25rem 0.5rem 1rem 0.5rem;
}

.invoiceDetailModal_evalAuditInfoBtn__z0c9f {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 2.5rem;
  min-height: 2.5rem;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #f9fafb;
  color: #4b5563;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.15s ease, color 0.15s ease;
}

.invoiceDetailModal_evalAuditInfoBtn__z0c9f:hover {
  background: #eef2ff;
  color: #3730a3;
}

.invoiceDetailModal_evalAuditInfoBtn__z0c9f:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px rgba(129, 140, 248, 0.45);
}

.invoiceDetailModal_modalSubtitle__iDKHH {
  font-size: 1.1rem;
  color: #333;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #eee;
}

.invoiceDetailModal_modalSubtitle__iDKHH:first-child {
  margin-top: 0;
}

.invoiceDetailModal_sectionPromesa__ki0QI {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}

.invoiceDetailModal_compactGrid__bHc8F {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 20px;
  padding: 4px 0;
  margin-bottom: 12px;
}

.invoiceDetailModal_compactGridSpan2__-kH7F {
  grid-column: span 2;
}

.invoiceDetailModal_compactGrid5__-UeqZ {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px 16px;
  margin-bottom: 20px;
}

@media (max-width: 992px) {
  .invoiceDetailModal_compactGrid5__-UeqZ {
    grid-template-columns: repeat(2, 1fr);
  }
}

.invoiceDetailModal_card__43wg\\+ {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.invoiceDetailModal_cardCol__AUVxT {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.invoiceDetailModal_label__u9ILg {
  font-size: 11px;
  color: #777;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.invoiceDetailModal_value__JvGbB {
  font-size: 13px;
  color: #212529;
  font-weight: 500;
  word-break: break-word;
}

.invoiceDetailModal_modernTable__dPm62 {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
}

.invoiceDetailModal_modernTable__dPm62 th {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 10px 8px;
  font-size: 11px;
  font-weight: 700;
  color: #495057;
}

.invoiceDetailModal_modernTable__dPm62 td {
  padding: 8px 10px;
  border-bottom: 1px solid #dee2e6;
  font-size: 12px;
  vertical-align: middle;
}

.invoiceDetailModal_modernTable__dPm62 tbody tr:last-child td {
  border-bottom: none;
}

.invoiceDetailModal_tableSummaryRow__iosDi {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 0.75rem;
  margin: -4px 0 12px;
  padding: 8px 10px;
  font-size: 12px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.invoiceDetailModal_tableSummaryRow__iosDi span {
  font-weight: 600;
}

.invoiceDetailModal_tableSummaryRow__iosDi strong {
  font-weight: 700;
  color: #0f172a;
}

.invoiceDetailModal_tableActionBtn__GA8F8 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-height: 1.8rem;
  padding: 0.25rem 0.6rem;
  border: 1px solid #cfd7df;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.invoiceDetailModal_tableActionBtn__GA8F8:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

.invoiceDetailModal_tableActionBtn__GA8F8:active {
  background: #eef2f7;
}

.invoiceDetailModal_tableActionBtn__GA8F8:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px rgba(148, 163, 184, 0.45);
}

.invoiceDetailModal_tableStatusBadge__stiLE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.45rem;
  padding: 0.18rem 0.5rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.invoiceDetailModal_tableStatusMuted__VHq7X {
  background: #f8fafc;
  color: #64748b;
  border-color: #e2e8f0;
}

.invoiceDetailModal_tableStatusNeutral__7qfzZ {
  background: #f1f5f9;
  color: #475569;
  border-color: #cbd5e1;
}

.invoiceDetailModal_tableStatusWarning__35N3S {
  background: #fffbeb;
  color: #92400e;
  border-color: #fde68a;
}

.invoiceDetailModal_tableStatusSuccess__Cgy-V {
  background: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.invoiceDetailModal_tableStatusDanger__\\+3HFg {
  background: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}

.invoiceDetailModal_statusGrid__8ow87 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 20px;
  background: rgba(248, 249, 250, 0.4);
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
}

.invoiceDetailModal_badge__MxAZs,
.invoiceDetailModal_badgeNeutral__ec6iM,
.invoiceDetailModal_badgeSuccess__B7Cci,
.invoiceDetailModal_badgeWarning__q2dtg,
.invoiceDetailModal_badgeDanger__U6Z-O,
.invoiceDetailModal_badgeInfo__M2dqV {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  display: inline-block;
}

.invoiceDetailModal_badgeNeutral__ec6iM {
  background: #343a40;
  color: #fff;
}

.invoiceDetailModal_badgeSuccess__B7Cci {
  background: #2e8b57;
  color: #fff;
}

.invoiceDetailModal_badgeWarning__q2dtg {
  background: #ffc107;
  color: #333;
}

.invoiceDetailModal_badgeDanger__U6Z-O {
  background: #dc3545;
  color: #fff;
}

.invoiceDetailModal_badgeInfo__M2dqV {
  background: #0dcaf0;
  color: #111;
}

.invoiceDetailModal_footerBar__LnBXo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 0.5rem 1rem 0.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid #eee;
  background: #fff;
  /* Esquinas inferiores acordes al diálogo */
  border-radius: 0 0 12px 12px;
}

.invoiceDetailModal_footerLeft__XhbdO {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.invoiceDetailModal_footerRight__LSddj {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* Misma altura / estilo base que Primary/Danger en modales premium (NEC, etc.) */
.invoiceDetailModal_footerModalBtn__5vM3O {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  margin: 0;
  min-height: 2.5rem;
  padding: 0.55rem 1.2rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;
}

.invoiceDetailModal_footerModalBtn__5vM3O:hover {
  filter: brightness(1.06);
}

.invoiceDetailModal_footerModalBtn__5vM3O:active {
  transform: scale(0.98);
}

.invoiceDetailModal_footerModalBtn__5vM3O:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 5px rgba(129, 140, 248, 0.45);
}

.invoiceDetailModal_footerModalBtn__5vM3O:disabled,
.invoiceDetailModal_footerModalBtn__5vM3O:disabled:hover,
.invoiceDetailModal_footerModalBtn__5vM3O:disabled:active {
  opacity: 0.48;
  cursor: not-allowed;
  filter: none;
  transform: none;
  box-shadow: none;
}

/* Acción advertencia (confirmar pago) — legible sobre fondo ámbar */
.invoiceDetailModal_footerModalBtn__5vM3O.invoiceDetailModal_footerModalBtnAmber__N29N9 {
  background: #f59e0b;
  color: #422006;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.invoiceDetailModal_footerModalBtn__5vM3O.invoiceDetailModal_footerModalBtnAmber__N29N9:hover {
  filter: brightness(1.04);
}

.invoiceDetailModal_footerModalBtn__5vM3O.invoiceDetailModal_footerModalBtnAmber__N29N9:focus-visible {
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 5px rgba(245, 158, 11, 0.55);
}

.invoiceDetailModal_linkLike__ywYdG {
  font-size: 13px;
  font-weight: 500;
  color: #0d6efd;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.invoiceDetailModal_linkLike__ywYdG:hover {
  color: #0a58ca;
}

.invoiceDetailModal_emptyCell__vnrZy {
  text-align: center;
  color: #6c757d;
  font-size: 13px;
  padding: 1rem !important;
}

.invoiceDetailModal_actionBtn__9jjG9 {
  width: 25px;
  height: 25px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.invoiceDetailModal_paymentObservationsBox__YGw0z {
  font-size: 13px;
  color: #212529;
  line-height: 1.5;
  padding: 12px 14px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 4px;
}

@media (max-width: 992px) {
  .invoiceDetailModal_compactGrid__bHc8F {
    grid-template-columns: repeat(2, 1fr);
  }
  .invoiceDetailModal_statusGrid__8ow87 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .invoiceDetailModal_compactGrid__bHc8F {
    grid-template-columns: 1fr;
  }
  .invoiceDetailModal_compactGridSpan2__-kH7F {
    grid-column: span 1;
  }
  .invoiceDetailModal_statusGrid__8ow87 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modals/invoice_detail/invoiceDetailModal.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,yEAAyE;EACzE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb;;uCAEqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;;uCAEqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,yEAAyE;AAC3E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb;;uCAEqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Portado de nuevo_front (consulta-documentos) — modal detalle comprobante */\n\n.dialogWide {\n  max-width: 1000px;\n  width: 100%;\n}\n\n.headerPremium {\n  background: #fafafa;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1.25rem 1.5rem;\n  /* Alineado con el radio del contenedor del modal (esquinas superiores) */\n  border-radius: 12px 12px 0 0;\n  margin-bottom: 0;\n}\n\n.titlePremium {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -0.01em;\n  margin: 0;\n  flex: 1;\n  padding-right: 0.5rem;\n}\n\n.closeIcon {\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.closeIcon:hover {\n  color: #374151;\n}\n\n.bodyWrap {\n  background: #fff;\n  max-height: min(70vh, 800px);\n  overflow-y: auto;\n  /* Separación respecto al header premium */\n  padding: 1.25rem 0.5rem 1rem 0.5rem;\n}\n\n.evalAuditInfoBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  min-width: 2.5rem;\n  min-height: 2.5rem;\n  padding: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: #f9fafb;\n  color: #4b5563;\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.evalAuditInfoBtn:hover {\n  background: #eef2ff;\n  color: #3730a3;\n}\n\n.evalAuditInfoBtn:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 4px rgba(129, 140, 248, 0.45);\n}\n\n.modalSubtitle {\n  font-size: 1.1rem;\n  color: #333;\n  font-weight: 600;\n  margin-top: 1.5rem;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.25rem;\n  border-bottom: 1px solid #eee;\n}\n\n.modalSubtitle:first-child {\n  margin-top: 0;\n}\n\n.sectionPromesa {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #eee;\n}\n\n.compactGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px 20px;\n  padding: 4px 0;\n  margin-bottom: 12px;\n}\n\n.compactGridSpan2 {\n  grid-column: span 2;\n}\n\n.compactGrid5 {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 12px 16px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 992px) {\n  .compactGrid5 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.card {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.cardCol {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.label {\n  font-size: 11px;\n  color: #777;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.value {\n  font-size: 13px;\n  color: #212529;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.modernTable {\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  text-align: center;\n}\n\n.modernTable th {\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  padding: 10px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #495057;\n}\n\n.modernTable td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #dee2e6;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.modernTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.tableSummaryRow {\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n  gap: 0.75rem;\n  margin: -4px 0 12px;\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #334155;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n}\n\n.tableSummaryRow span {\n  font-weight: 600;\n}\n\n.tableSummaryRow strong {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.tableActionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  min-height: 1.8rem;\n  padding: 0.25rem 0.6rem;\n  border: 1px solid #cfd7df;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #334155;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.tableActionBtn:hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n  color: #0f172a;\n}\n\n.tableActionBtn:active {\n  background: #eef2f7;\n}\n\n.tableActionBtn:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 4px rgba(148, 163, 184, 0.45);\n}\n\n.tableStatusBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1.45rem;\n  padding: 0.18rem 0.5rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.tableStatusMuted {\n  background: #f8fafc;\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n\n.tableStatusNeutral {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #cbd5e1;\n}\n\n.tableStatusWarning {\n  background: #fffbeb;\n  color: #92400e;\n  border-color: #fde68a;\n}\n\n.tableStatusSuccess {\n  background: #ecfdf5;\n  color: #047857;\n  border-color: #a7f3d0;\n}\n\n.tableStatusDanger {\n  background: #fef2f2;\n  color: #b91c1c;\n  border-color: #fecaca;\n}\n\n.statusGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px 20px;\n  background: rgba(248, 249, 250, 0.4);\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #f0f0f0;\n}\n\n.badge,\n.badgeNeutral,\n.badgeSuccess,\n.badgeWarning,\n.badgeDanger,\n.badgeInfo {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.badgeNeutral {\n  background: #343a40;\n  color: #fff;\n}\n\n.badgeSuccess {\n  background: #2e8b57;\n  color: #fff;\n}\n\n.badgeWarning {\n  background: #ffc107;\n  color: #333;\n}\n\n.badgeDanger {\n  background: #dc3545;\n  color: #fff;\n}\n\n.badgeInfo {\n  background: #0dcaf0;\n  color: #111;\n}\n\n.footerBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 0.5rem 1rem 0.5rem;\n  margin-top: 0.5rem;\n  border-top: 1px solid #eee;\n  background: #fff;\n  /* Esquinas inferiores acordes al diálogo */\n  border-radius: 0 0 12px 12px;\n}\n\n.footerLeft {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.footerRight {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n/* Misma altura / estilo base que Primary/Danger en modales premium (NEC, etc.) */\n.footerModalBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  margin: 0;\n  min-height: 2.5rem;\n  padding: 0.55rem 1.2rem;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;\n}\n\n.footerModalBtn:hover {\n  filter: brightness(1.06);\n}\n\n.footerModalBtn:active {\n  transform: scale(0.98);\n}\n\n.footerModalBtn:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 5px rgba(129, 140, 248, 0.45);\n}\n\n.footerModalBtn:disabled,\n.footerModalBtn:disabled:hover,\n.footerModalBtn:disabled:active {\n  opacity: 0.48;\n  cursor: not-allowed;\n  filter: none;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Acción advertencia (confirmar pago) — legible sobre fondo ámbar */\n.footerModalBtn.footerModalBtnAmber {\n  background: #f59e0b;\n  color: #422006;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.footerModalBtn.footerModalBtnAmber:hover {\n  filter: brightness(1.04);\n}\n\n.footerModalBtn.footerModalBtnAmber:focus-visible {\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 5px rgba(245, 158, 11, 0.55);\n}\n\n.linkLike {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0d6efd;\n  text-decoration: underline;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.linkLike:hover {\n  color: #0a58ca;\n}\n\n.emptyCell {\n  text-align: center;\n  color: #6c757d;\n  font-size: 13px;\n  padding: 1rem !important;\n}\n\n.actionBtn {\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.paymentObservationsBox {\n  font-size: 13px;\n  color: #212529;\n  line-height: 1.5;\n  padding: 12px 14px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 4px;\n}\n\n@media (max-width: 992px) {\n  .compactGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .statusGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .compactGrid {\n    grid-template-columns: 1fr;\n  }\n  .compactGridSpan2 {\n    grid-column: span 1;\n  }\n  .statusGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogWide": `invoiceDetailModal_dialogWide__hVPn1`,
	"headerPremium": `invoiceDetailModal_headerPremium__zLUl+`,
	"titlePremium": `invoiceDetailModal_titlePremium__x-+kY`,
	"closeIcon": `invoiceDetailModal_closeIcon__CTFl6`,
	"bodyWrap": `invoiceDetailModal_bodyWrap__1DwgU`,
	"evalAuditInfoBtn": `invoiceDetailModal_evalAuditInfoBtn__z0c9f`,
	"modalSubtitle": `invoiceDetailModal_modalSubtitle__iDKHH`,
	"sectionPromesa": `invoiceDetailModal_sectionPromesa__ki0QI`,
	"compactGrid": `invoiceDetailModal_compactGrid__bHc8F`,
	"compactGridSpan2": `invoiceDetailModal_compactGridSpan2__-kH7F`,
	"compactGrid5": `invoiceDetailModal_compactGrid5__-UeqZ`,
	"card": `invoiceDetailModal_card__43wg+`,
	"cardCol": `invoiceDetailModal_cardCol__AUVxT`,
	"label": `invoiceDetailModal_label__u9ILg`,
	"value": `invoiceDetailModal_value__JvGbB`,
	"modernTable": `invoiceDetailModal_modernTable__dPm62`,
	"tableSummaryRow": `invoiceDetailModal_tableSummaryRow__iosDi`,
	"tableActionBtn": `invoiceDetailModal_tableActionBtn__GA8F8`,
	"tableStatusBadge": `invoiceDetailModal_tableStatusBadge__stiLE`,
	"tableStatusMuted": `invoiceDetailModal_tableStatusMuted__VHq7X`,
	"tableStatusNeutral": `invoiceDetailModal_tableStatusNeutral__7qfzZ`,
	"tableStatusWarning": `invoiceDetailModal_tableStatusWarning__35N3S`,
	"tableStatusSuccess": `invoiceDetailModal_tableStatusSuccess__Cgy-V`,
	"tableStatusDanger": `invoiceDetailModal_tableStatusDanger__+3HFg`,
	"statusGrid": `invoiceDetailModal_statusGrid__8ow87`,
	"badge": `invoiceDetailModal_badge__MxAZs`,
	"badgeNeutral": `invoiceDetailModal_badgeNeutral__ec6iM`,
	"badgeSuccess": `invoiceDetailModal_badgeSuccess__B7Cci`,
	"badgeWarning": `invoiceDetailModal_badgeWarning__q2dtg`,
	"badgeDanger": `invoiceDetailModal_badgeDanger__U6Z-O`,
	"badgeInfo": `invoiceDetailModal_badgeInfo__M2dqV`,
	"footerBar": `invoiceDetailModal_footerBar__LnBXo`,
	"footerLeft": `invoiceDetailModal_footerLeft__XhbdO`,
	"footerRight": `invoiceDetailModal_footerRight__LSddj`,
	"footerModalBtn": `invoiceDetailModal_footerModalBtn__5vM3O`,
	"footerModalBtnAmber": `invoiceDetailModal_footerModalBtnAmber__N29N9`,
	"linkLike": `invoiceDetailModal_linkLike__ywYdG`,
	"emptyCell": `invoiceDetailModal_emptyCell__vnrZy`,
	"actionBtn": `invoiceDetailModal_actionBtn__9jjG9`,
	"paymentObservationsBox": `invoiceDetailModal_paymentObservationsBox__YGw0z`
};
export default ___CSS_LOADER_EXPORT___;
